import TheGrid from '@/views/admins/grid'
import Edit from '@/views/admins/edit'

export default {
  path: '/admins',
  redirect: '/admins/index',
  name: 'admins',
  meta: {
    auth: {
      redirect: {
        name: 'admins.index'
      },
      forbiddenRedirect: '/dashboard'
    },
    label: 'Utilizadores'
  },
  component: {
    render(c) {
      return c('router-view')
    }
  },
  children: [{
    path: 'index',
    name: 'admins.index',
    component: TheGrid,
    meta: {
      auth: true,
      roles: ['SUPER'],
      forbiddenRedirect: '/dashboard',
      label: 'Lista'
    }
  }, {
    path: 'create',
    name: 'admins.create',
    component: Edit,
    meta: {
      auth: true,
      roles: ['SUPER'],
      forbiddenRedirect: '/dashboard',
      label: 'Criar'
    }
  }, {
    path: 'edit/:id',
    name: 'admins.edit',
    component: Edit,
    meta: {
      auth: true,
      roles: ['SUPER'],
      forbiddenRedirect: '/dashboard',
      label: 'Editar'
    }
  }]
}
